import React from 'react';

export enum DeliveryPassStatusEnum {
  AVAILABLE = 'AVAILABLE', // User does not have a delivery pass, but it is available for them to purchase
  ACTIVE = 'ACTIVE', // User has an active delivery pass
  UNKNOWN = 'UNKNOWN', // It is unknown if the user has a delivery pass or not, or a status attempt has not been successfully made
}

const DeliveryPassStatusContext = React.createContext<DeliveryPassStatusEnum>(
  DeliveryPassStatusEnum.UNKNOWN,
);
export default DeliveryPassStatusContext;
